// https://material-ui.com/api/tooltip/

import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Tooltip as MaterialTooltip } from '@material-ui/core';

export const TooltipTopStart = "top-start";
export const TooltipTop = "top";
export const TooltipTopEnd = "top-end";

export const TooltipLeftStart = "left-start";
export const TooltipLeft = "left";
export const TooltipLeftEnd = "left-end";

export const TooltipRightStart = "right-start";
export const TooltipRight = "right";
export const TooltipRightEnd = "right-end";

export const TooltipBottomStart = "bottom-start";
export const TooltipBottom = "bottom";
export const TooltipBottomEnd = "bottom-end";


const styles = theme => ({
  root: {
  }
});

/**
 * Tooltip with text message. Displays on hover to some html-element. Must wrap html-element
 * @name Tooltip
 * @param {object} props React component properties
 * @param {string} props.content Content for display in tooltip
 * @param {string} [props.className] CSS-class of button
 * @param {string} [props.placement = "top"] Placement of tooltip. Source {@link https://material-ui.com/components/tooltips/#positioned-tooltips}. Available values:
 *  - top-start
 *  - top
 *  - top-end
 *  - left-start
 *  - left
 *  - left-end
 *  - right-start
 *  - right
 *  - right-end
 *  - bottom-start
 *  - bottom
 *  - bottom-end
 * 
 * NOTE: for providing variant, please, import necessary variant as constant from file "components/base/components/tooltip.js.jsx" via import { Constant } from "path/to/file.js"
 * @example
 * return (
 *    <Tooltip content = { 
 *      <div className = { "tooltip" }>
 *        { "Explanation" }
 *      </div> 
 *    }>
 *      <div className = { "content" } >
 *        { "Please, explain me!" }
 *      </div>
 *    </Tooltip>
 * )
*/

class Tooltip extends React.Component {

  render() {
    const { classes, className } = this.props;

    const { placement, content, children } = this.props;

    return <MaterialTooltip className = { clsx(classes.root, className) }
                            placement = { placement }
                            title = { content }
                            arrow >
      <div>
        { children }
      </div>
    </MaterialTooltip>
  }
}

Tooltip.propTypes = {
  placement: PropTypes.oneOf([
    TooltipTopStart, TooltipTop, TooltipTopEnd,
    TooltipLeftStart, TooltipLeft, TooltipLeftEnd,
    TooltipRightStart, TooltipRight, TooltipRightEnd,
    TooltipBottomStart, TooltipBottom, TooltipBottomEnd
  ]),
  content: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

Tooltip.defaultProps = {
  placement: TooltipTop
}

export default withStyles(styles)(Tooltip);